import { useSnackbar } from 'notistack';
import { useEffect, useState } from "react";
// next
import { useRouter } from 'next/router';
import {
  Box,
  IconButton,
  Skeleton,
  Typography,
} from "@mui/material";;
// hooks
import useAuth from "../../hooks/useAuth";
import useResponsive from "../../hooks/useResponsive";
// components
import Page from "../../components/Page";
import SvgIconStyle from "../../components/SvgIconStyle";
import {
  ScoutCrewCard,
} from ".";
import {
  FliersDetailDrawer,
  FliersDetailDialog,
} from '../fliers';
// swr
import useSWR from 'swr';
// utils
import axiosSWRFetcher from '../../utils/swrFetcher';
// routes
import { PATH_SCOUT } from '../../routes/paths';


// ----------------------------------------------------------------------

export default function ProScoutPage() {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const companyId = user?.employee?.company?.[0].id;
  const router = useRouter();
  const { push, query } = router;
  const { enqueueSnackbar } = useSnackbar();

  const [isOpenFliersDetailDrawer, setIsOpenFliersDetailDrawer] = useState(false);
  const [isOpenFliersDetailDialog, setIsOpenFliersDetailDialog] = useState(false);
  const [selectedCoffeeChat, setSelectedCoffeeChat] = useState(null);

  const { data: scouts, isLoading, mutate: mutateScout } = useSWR(companyId ? `/api/company/${companyId}/scout/` : null, axiosSWRFetcher, {errorRetryInterval: 2000, revalidateOnFocus: false});

  const selectCrew = (crew) => {
    if (crew) {
      setSelectedCoffeeChat({ crew: { id: crew.id }, coffee_chat_status: "evaluable", proxy: crew.scout_proxy_at });
      if (smUp) {
        setIsOpenFliersDetailDrawer(true);
      } else {
        setIsOpenFliersDetailDialog(true);
      }
    }
  }

  const selectCrewById = (crewId) => {
    scouts?.find((crew) => {
      if (parseInt(crewId) === crew?.id) {
        selectCrew(crew);
      }
    });
  }

  useEffect(() => {
    if (query?.profile && !isLoading) {
      selectCrewById(query?.profile);
    }
  }, [query, isLoading]);

  const selectNextCrewOrMoveBack = (nextCrewId) => {
    setIsOpenFliersDetailDialog(false);
    setIsOpenFliersDetailDrawer(false);
    if (!nextCrewId) {
      enqueueSnackbar("추천받은 크루를 모두 확인했습니다.");
      push({pathname: PATH_SCOUT.root});
    } else {
      mutateScout();
    }
  }

  return (
    <Page title="Scout" sx={{ pb: { xs: 4, sm : 6 } }}>
      <Box sx={{ px: { xs: 3, sm: 5 }, mx: "auto", mb: 3 }} maxWidth="lg">
        <IconButton color="inherit" edge="start" sx={{ mt: 0.5 }} onClick={() => push({pathname: PATH_SCOUT.root})}>
          <SvgIconStyle src={`/icons/chevron-left.svg`} sx={{ width: 24, height: 24, color: "primary.main" }} />
        </IconButton>
        <Typography variant="h5">
          마음에 드는 크루를 내 인재풀에 추가하세요.
        </Typography>
      </Box>
      {isLoading && (
      <Box sx={{ px: { xs: 3, md: 5 }, mx: "auto" }} maxWidth="lg">
        <Box sx={{ width: 1 }}>
          <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2 }} />
        </Box>
      </Box>
      )}
      {!isLoading && scouts?.length > 0 && (
      <Box sx={{ px: { xs: 3, md: 5 }, mx: "auto", ...smUp && { minHeight: 'calc(100vh - 382px)' }, ...!smUp && { minHeight: 'calc(100vh - 310px)' } }} maxWidth="lg">
        {/* crew cards */}
        <Box
          sx={{
            mt: 2,
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              md: 'repeat(2, 1fr)',
              lg: 'repeat(3, 1fr)',
            },
            gap: 2,
          }}
        >
          {scouts.map((scout, index) => (
            <ScoutCrewCard profile={scout} key={index} selectProfile={selectCrew} proPlan reload={mutateScout} />
          ))}
        </Box>
      </Box>
      )}
      <FliersDetailDrawer
        isOpen={isOpenFliersDetailDrawer}
        closeDrawer={() => setIsOpenFliersDetailDrawer(false)}
        coffeeChat={selectedCoffeeChat}
        reload={selectNextCrewOrMoveBack}
        reloadScout={mutateScout}
      />
      <FliersDetailDialog
        isOpen={isOpenFliersDetailDialog}
        closeDialog={() => { setIsOpenFliersDetailDialog(false) }}
        coffeeChat={selectedCoffeeChat}
        reload={selectNextCrewOrMoveBack}
        reloadScout={mutateScout}
      />
    </Page>
  )
}
